import React from 'react';
import { Box, Button, Container, Heading, Image, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { expertsGallery } from '../data/gallery';
import { whatsappHref } from '../data/brand';
export function Experts() {
  return <Box as="section" id="expertos" bg="plum.900" py={{
    base: 14,
    md: 24
  }} data-id="element-63" data-mp="2ugt5tx3z2yf2">
      <Container maxW="76rem" px={{
      base: 4,
      md: 6
    }} data-id="element-64" data-mp="1xq0rb3wotefe">
        <VStack spacing={4} textAlign="center" maxW="50rem" mx="auto" data-id="element-65" data-mp="1xrljimvj4la3">
          <Text fontSize="xs" fontWeight={600} letterSpacing="0.24em" textTransform="uppercase" color="gold.300" data-id="element-66" data-mp="22oc15emzfoxm">
            Nuestro equipo
          </Text>
          <Heading as="h2" fontSize={{
          base: '1.75rem',
          md: '2.5rem'
        }} color="cream.50" data-id="element-67" data-mp="2bj02itpfsmh5">
            Contamos con Brujos y Hechiceros Expertos En todo tipo de Magia..
          </Heading>
          <Box w="3.5rem" h="1px" bg="gold.400" opacity={0.8} data-id="element-68" data-mp="1iztf35x9wrn5" />
          <Text fontSize={{
          base: 'md',
          md: 'lg'
        }} color="plum.100" data-id="element-69" data-mp="3e008x1x4fhrz">
            Cada consulta se atiende de forma personalizada y se explica con claridad antes de
            comenzar. Los resultados pueden variar según cada persona.
          </Text>
        </VStack>

        <SimpleGrid columns={{
        base: 1,
        md: 2
      }} spacing={{
        base: 4,
        md: 6
      }} mt={{
        base: 10,
        md: 14
      }} data-id="element-70" data-mp="347cdoblshlvd">
          {expertsGallery.map(item => <Box key={item.src} position="relative" borderRadius="xl" overflow="hidden" border="1px solid" borderColor="whiteAlpha.300" data-id="element-71" data-mp="2u9eptp7udr3a">
              <Image src={item.src} alt={item.alt} w="100%" h={{
            base: '16rem',
            md: '22rem'
          }} objectFit="cover" loading="lazy" data-id="element-72" data-mp="2gbzwwaidr16k" />
              <Box position="absolute" inset={0} bg="linear-gradient(180deg, rgba(13,6,19,0) 45%, rgba(13,6,19,0.85) 100%)" aria-hidden="true" data-id="element-73" data-mp="eloecm2vp27j" />
              <Text position="absolute" bottom={4} left={5} right={5} fontSize="sm" fontWeight={500} color="cream.50" data-id="element-74" data-mp="2dtenhsg2ytnv">
                {item.caption}
              </Text>
            </Box>)}
        </SimpleGrid>

        <VStack mt={{
        base: 8,
        md: 10
      }} data-id="element-75" data-mp="2wqfvlm4xl9w1">
          <Button as="a" href={whatsappHref('orientación con sus especialistas')} target="_blank" rel="noopener noreferrer" variant="whatsapp" size="lg" h={{
          base: '3.5rem',
          md: '3.75rem'
        }} px={8} fontSize={{
          base: 'sm',
          md: 'md'
        }} w={{
          base: '100%',
          sm: 'auto'
        }} leftIcon={<WhatsAppIcon size={21} data-id="element-77" data-mp="1be4pqbiwvtvu" />} data-id="element-76" data-mp="2wpei7b0g0bb5">
            CONSULTAR POR WHATSAPP
          </Button>
        </VStack>
      </Container>
    </Box>;
}